"use client";

import React from "react";
import { Youtube, Mic, Play, Headphones, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const videos = [{
  id: "v1",
  title: "The Future of Civic Tech: A Panel Discussion",
  date: "Nov 15, 2023",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/youtube_thumb_civic_tech.png"
}, {
  id: "v2",
  title: "Understanding Local Government Budgets",
  date: "Oct 28, 2023",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/youtube_thumb_budgets.png"
}, {
  id: "v3",
  title: "Advocacy 101: Making Your Voice Heard",
  date: "Sep 12, 2023",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/youtube_thumb_advocacy.png"
}];
const podcasts = [{
  id: "p1",
  title: "Episode 45: Data Privacy and Public Policy",
  date: "Nov 20, 2023",
  duration: "42 min",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/podcast_cover_privacy.png"
}, {
  id: "p2",
  title: "Episode 44: Interview with Mayor Jane Doe",
  date: "Nov 05, 2023",
  duration: "55 min",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/podcast_cover_mayor.png"
}, {
  id: "p3",
  title: "Episode 43: The Impact of Open Data",
  date: "Oct 18, 2023",
  duration: "38 min",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/podcast_cover_opendata.png"
}];
export default function MultimediaLinks() {
  return;
}